module.exports = __webpack_public_path__ + "static/img/2.4bd3604.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/cpxh/2.jpg
// module id = a0LH
// module chunks = 0